/**
 * 最新消息後台：封面／附件允許的類型（前端選檔與送出前檢查）。
 * 若 API 仍回傳「檔案類型只能是 …」類訊息，代表後端 uploadImage／uploadAttachment 也需同步放寬。
 */

const extLower = (fileName: string): string => {
  const i = fileName.lastIndexOf('.');
  return i >= 0 ? fileName.slice(i + 1).toLowerCase() : '';
};

const COVER_MIMES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/pjpeg',
  'image/png',
  'image/webp',
]);

const COVER_EXTS = new Set(['jpg', 'jpeg', 'png', 'webp']);

const ATTACHMENT_MIMES = new Set([
  'application/zip',
  'application/x-zip-compressed',
  'multipart/x-zip',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/jpg',
  'image/pjpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'video/mp4',
  'video/quicktime',
]);

const ATTACHMENT_EXTS = new Set([
  'zip',
  'doc',
  'docx',
  'pdf',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
  'jpg',
  'jpeg',
  'png',
  'gif',
  'mp4',
  'mov',
  'webp',
]);

export const LATEST_NEWS_COVER_FILE_ACCEPT = [
  ...COVER_MIMES,
  ...[...COVER_EXTS].map(e => `.${e}`),
].join(',');

export const LATEST_NEWS_ATTACHMENT_FILE_ACCEPT = [
  ...ATTACHMENT_MIMES,
  ...[...ATTACHMENT_EXTS].map(e => `.${e}`),
].join(',');

const coverAllowedDesc = 'JPEG、JPG、PNG、WebP';

const attachmentAllowedDesc =
  'zip、doc、docx、pdf、ppt、pptx、xls、xlsx、jpg、jpeg、png、gif、mp4、mov、webp';

export function validateLatestNewsCoverPick(file: File): string | null {
  const mime = (file.type || '').trim().toLowerCase();
  if (mime && COVER_MIMES.has(mime)) return null;
  const e = extLower(file.name);
  if (e && COVER_EXTS.has(e)) return null;
  return `封面圖僅支援 ${coverAllowedDesc}。`;
}

/** 由 data URL / Blob 得到的 MIME（不含副檔名時） */
export function validateLatestNewsCoverBlobMime(mime: string): string | null {
  const m = (mime || '').trim().toLowerCase();
  if (m && COVER_MIMES.has(m)) return null;
  return `封面圖僅支援 ${coverAllowedDesc}。`;
}

export function validateLatestNewsAttachmentPick(file: File): string | null {
  const mime = (file.type || '').trim().toLowerCase();
  if (mime && ATTACHMENT_MIMES.has(mime)) return null;
  const e = extLower(file.name);
  if (e && ATTACHMENT_EXTS.has(e)) return null;
  return `此附件類型不支援；請使用 ${attachmentAllowedDesc}。`;
}
